import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help.settings',
  imports: [CommonModule],
  templateUrl: './help.settings.component.html',
  styleUrl: './help.settings.component.scss'
})
export class HelpSettingsComponent implements OnInit {

  selectedSection = 'settings';
  preferenceExpanded = true;
  userManagementExpanded = true;

  constructor(
    private navigationService: HelpNavigationService
  ) { }

  ngOnInit(): void {

    this.navigationService.selectedSection.next('settings');

    this.navigationService.selectedSection.subscribe(section => {

      this.selectedSection = section;

      setTimeout(() => {

        const element =
          document.getElementById(section);

        const container =
          document.querySelector('.help-content') as HTMLElement;

        if (element && container) {

          container.scrollTo({
            top: element.offsetTop - 40,
            behavior: 'smooth'
          });

        }

      }, 50);

    });

  }

  changeSection(section: string): void {

    this.navigationService.selectedSection.next(section);

  }

}
